var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.465 26.779a13 13 0 100-26 13 13 0 000 26zm-6.329-16.66a1.97 1.97 0 011.896-1.215h8.84a1.999 1.999 0 011.9 1.165.352.352 0 01.048.32.349.349 0 01-.235.225l-5.86 3.061a.489.489 0 01-.487 0L7.3 10.59a.31.31 0 01-.164-.47zm.387 1.953c1.847.964 3.691 1.926 5.534 2.885.252.15.566.15.818 0 1.834-.962 3.67-1.915 5.51-2.86a.615.615 0 01.171-.065.31.31 0 01.409.322v3.674c.015.318.004.635-.034.951-.153.975-1 1.69-1.986 1.675H9.026a2.007 2.007 0 01-1.986-1.495 2.095 2.095 0 01-.075-.52v-4.245c0-.357.228-.492.558-.323z","fill":"#2A87F5"}));
}

Email.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = Email;

Email.default = Email;
